module.exports = __webpack_public_path__ + "static/media/proj15_img14.6b99a7e8.jpg";